export enum LineHeight {
  TIGHT = 1.1, // em
  MODERATE = 1.25, // em
  LOOSE = 1.5, // em
}
